/** @format */
import angular from 'angular';
import { displaySelectedParametersModule } from './displaySelectedParameters.component';
import { displaySelectedParametersStaticModule } from './displaySelectedParametersStatic.component';
import { searchAndResultsModule } from './searchAndResults.dir';
import { searchComponentUtilsServiceModule } from './searchComponentUtils.service';
import { searchEventConstantModule } from './searchEvent.constant';
import { searchFilterOptionsMenuModule } from './searchFilterOptionsMenu.component';
import { searchFilterModule } from './searchFilters/searchFilter.component';
import { searchParameterModelsModule } from './searchParameterModels';
import { searchParameterServiceModule } from './searchParameters';
import { searchParametersDirectiveModule } from './searchParameters.dir';
import { searchParameterStorageServiceModule } from './searchParameterStorage.service';
import { searchResultInfoModule } from './searchResultInfo.component';

export const commonSearchModule = 'sis-components.search';

/**
 * This module is defined because these submodules are rarely used alone. I personally do not usually like these modules that group other
 * modules or even worse, modules that are defined across multiple files. In this case the tediousness of fixing imports blew my mind. You
 * could justify this choice by saying that this is a (search) library.
 */
angular.module(commonSearchModule, [
    searchFilterModule,
    displaySelectedParametersModule,
    displaySelectedParametersStaticModule,
    searchAndResultsModule,
    searchFilterOptionsMenuModule,
    searchParameterModelsModule,
    searchParametersDirectiveModule,
    searchParameterServiceModule,
    searchParameterStorageServiceModule,
    searchResultInfoModule,
    searchComponentUtilsServiceModule,
    searchEventConstantModule,
]);
